
import http from '@utils/http';

export const logIn = function (options) {
  // 后端判断登陆 登陆时把上一次登陆token带过去
  const oldToken = window.localStorage.getItem('dingdingAuthToken');
  // return http.get(`/api/login/dingding?code=${options}${oldToken ? `&token=${oldToken}` : ''}`);
  return http.get(`/api/infoLogin/weilai/dingding?code=${options}${oldToken ? `&token=${oldToken}` : ''}`);
};

export function jurisdiction() {
  return http.post('/api/right/apps', {});
}
